import { CargoCompanyListItem } from "../../../../../../common/services/cargo-company/cargo-company/list/cargo-company-list";
import billingsCargoOrderListingFactory from "../../common/billings-cargo-order-listing.factory";
import BillingsCargoOrderListingByRailyCargoCompanySelectOption from "./types/billings-cargo-order-listing-by-raily-cargo-company-select-option";

const createCargoCompanySelectOption = (
  responseCargoCompany: CargoCompanyListItem,
): BillingsCargoOrderListingByRailyCargoCompanySelectOption => {
  return {
    label: responseCargoCompany.displayName,
    value: {
      uuid: responseCargoCompany.uuid,
      displayName: responseCargoCompany.displayName,
    },
  };
};

const createCargoCompanySelectOptions = (
  responseCargoCompanies: CargoCompanyListItem[],
): BillingsCargoOrderListingByRailyCargoCompanySelectOption[] => {
  return responseCargoCompanies.map(createCargoCompanySelectOption);
};

const billingsCargoOrderListingByRailyFactory = {
  createCargoCompanySelectOptions,
  createListingItems: billingsCargoOrderListingFactory.createListingItems,
};

export default billingsCargoOrderListingByRailyFactory;
